
import Axios from 'axios';
import { Message } from '@/model/message';
import { CategorieMessage } from '@/model/enum-types/categorie-message';
import { CodeDomaine } from '@/model/enum-types/code-domaine';
import { ApiUtils } from './api-utils';

export class MessageApi {
  static getMessages (categorie:CategorieMessage): Promise<Message[]> {
    const params = ApiUtils.buildQueryParamsStr({ categorie });
    return ApiUtils.responseParser(Axios.get('/web/v1/messages' + params), [Message]);
  }
}
